module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// /srv/zulip-npm-cache/9635f743433da9fbc85f14e98ead66ea61b6ba1d/~/i18next-browser-languagedetector/index.js
// module id = 21
// module chunks = 0